import csv_src from '../assets/images/fileIcons/csv.png'
import xlsx_src from '../assets/images/fileIcons/excel.png'
import pdf_src from '../assets/images/fileIcons/pdf.png'

/**
 * Returns the icon src for a given file type or filename.
 * @param fileTypeOrName - The MIME type (e.g. 'application/pdf') or filename (e.g. 'report.pdf')
 */
export function getFileIconSrc(fileTypeOrName: string): string {
  // Try to match by MIME type first
  switch (fileTypeOrName) {
    case 'application/pdf':
      return pdf_src
    case 'application/vnd.ms-excel':
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      return xlsx_src
    case 'text/csv':
      return csv_src
    default:
      break
  }
  // Fallback: try to match by file extension
  const ext = fileTypeOrName.split('.').pop()?.toLowerCase()
  switch (ext) {
    case 'pdf':
      return pdf_src
    case 'xls':
    case 'xlsx':
      return xlsx_src
    case 'csv':
      return csv_src
    default:
      return pdf_src // Default icon
  }
}
